/**
 * Controles del Power Dialer: progreso y botón de detener.
 * Se muestra en el FloatingDialerWidget cuando hay una campaña activa.
 */

import {
  Badge,
  BlockStack,
  Box,
  Button,
  InlineStack,
  ProgressBar,
  Text,
} from '@/lib/polaris';

interface PowerDialerControlsProps {
  running: boolean;
  progress: { done: number; total: number } | null;
  onStop: () => void;
}

export function PowerDialerControls({ running, progress, onStop }: PowerDialerControlsProps) {
  if (!running) return null;

  const done = progress?.done ?? 0;
  const total = progress?.total ?? 0;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <Box padding="300" background="bg-surface-warning" borderRadius="200">
      <BlockStack gap="200">
        <InlineStack align="space-between" blockAlign="center">
          <InlineStack gap="200" blockAlign="center">
            <Badge tone="warning">Power Dialer</Badge>
            <Text as="span" variant="bodySm" fontWeight="semibold">
              {done} / {total} llamadas
            </Text>
          </InlineStack>
          <Button
            tone="critical"
            variant="primary"
            size="slim"
            onClick={onStop}
          >
            Detener
          </Button>
        </InlineStack>
        {total > 0 ? (
          <ProgressBar progress={pct} size="small" tone="primary" />
        ) : null}
      </BlockStack>
    </Box>
  );
}
